import { Expose } from "class-transformer";
import type { SenderTypeEnum } from "../enums/sender-type.enum";

export interface IChatbotMessage {
  id?: number;
  senderType: SenderTypeEnum;
  text: string;
}

export class ChatbotMessage implements IChatbotMessage {
  @Expose()
  id?: number;

  @Expose()
  senderType!: SenderTypeEnum;

  @Expose({ name: "message" })
  text!: string;
}
